import { MenuItem } from "@mui/material";
import ConfirmDialog from "components/ConfirmDialog";
import ThreeDotsMenu from "components/ThreeDots/ThreeDotsMenu";
import useGlobalContext from "hooks/globalData";
import { useState } from "react";
import { FormattedMessage as T } from "react-intl";
import { useQuery, useQueryClient } from "react-query";
import { InvalidateExamAttemptRequest } from "services/KnowfullyAdminClient";
import { UserEvaluationStatusConstants } from "types/common-types";
import { ExamAttemptModel } from "./ExamAttemptsList";

type InvalidateExamAttemptProps = {
  value: ExamAttemptModel;
  userId: string;
};

const InvalidateExamAttempt = ({
  value,
  userId,
}: InvalidateExamAttemptProps) => {
  const queryClient = useQueryClient();
  const { organizationUserService, userEvaluationService } = useGlobalContext();
  const onInvalidateExamAttempt = () => {
    setInvalidateExamAttemptDialogOpen(true);
  };

  const [
    invalidateExamAttemptDialogOpen,
    setInvalidateExamAttemptDialogOpen,
  ] = useState(false);

  const userResult = useQuery(
    ["getOrganizationUserDetails", userId],
    () => organizationUserService.getOrganizationUserDetails(userId),
    {
      enabled: !!userId,
    }
  );

  const user = userResult?.data;

  const onHandleConfirm = async () => {
    await userEvaluationService.invalidateExamAttempt(
      InvalidateExamAttemptRequest.fromJS({
        userEvaluationId: value.id,
        organizationId: user?.organizationId,
        userId: user?.id,
      })
    );

    queryClient.invalidateQueries("examAttempts");
    setInvalidateExamAttemptDialogOpen(false);
  };

  return (
    <>
      <ThreeDotsMenu>
        <MenuItem
          disabled={
            value.result !== "Fail" ||
            value.status !== UserEvaluationStatusConstants.Completed
          }
          onClick={() => onInvalidateExamAttempt()}
        >
          <T id="invalidateExam" />
        </MenuItem>
      </ThreeDotsMenu>

      <ConfirmDialog
        dialogTitleKey={"invalidateExamAttempt"}
        contentKey={"invalidateExamWarning"}
        open={invalidateExamAttemptDialogOpen}
        onCancel={() => {
          setInvalidateExamAttemptDialogOpen(false);
        }}
        handleConfirm={onHandleConfirm}
        confirmLabel="confirmButton"
      />
    </>
  );
};

export default InvalidateExamAttempt;
